import { render, staticRenderFns } from "./MiddlePanel.vue?vue&type=template&id=1d794dbc&"
import script from "./MiddlePanel.vue?vue&type=script&lang=js&"
export * from "./MiddlePanel.vue?vue&type=script&lang=js&"
import style0 from "./MiddlePanel.vue?vue&type=style&index=0&id=1d794dbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports